// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PhoneTwoToneSvg from "@fishx/icons-svg/es/asn/PhoneTwoTone";
import FishxIcon from '../components/FishxIcon';

var PhoneTwoTone = function PhoneTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PhoneTwoToneSvg
  }));
};

PhoneTwoTone.displayName = 'PhoneTwoTone';
export default React.forwardRef(PhoneTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PhoneTwoTone.js
// module id = 3771
// module chunks = 0